
import { defineComponent } from "vue";

export default defineComponent({
	name: "prop-selector",
	props: {
		availableProps: {
			type: Object,
			default: () => {
				return {} as any;
			}
		},
		selectedProp: {
			type: Object,
			default: () => {
				return {} as any;
			}
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			searchTerm: ""
		};
	},
	mounted() {
		const openProp = (this.availableProps as any).filter((item: any) => item.open);
		if (openProp.length == 0) {
			(this.availableProps as any)[0].open = true;
		}
	},
	methods: {
		selectProp(prop: any) {
			this.$emit("selectProp", prop);
		}
	}
});
